define('responsive-pitch-fx/lib/helpers/cssClass',['require','exports','module','../enums/config'],function(require,exports,module){
	var config = require( '../enums/config' );

	return function(name){
		return config.className + (name ? "-" + name : '');
	}
});
